// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2b41009e] .modal-footer{justify-content:flex-start}[data-v-2b41009e] .img__logo-header{height:auto;max-width:335px}[data-v-2b41009e] .modal-content{height:90vh!important;border:none;box-shadow:0 5rem 14rem 0 hsla(0,0%,100%,.3),0 .8rem 2.3rem rgba(0,0,0,.2),0 .2rem .3rem rgba(0,0,0,.2)}[data-v-2b41009e] .modal-content .modal-body{overflow-y:auto}", ""]);
// Exports
module.exports = exports;
